<template>
  <v-layout row wrap class="ch-search-filter-wrapper">
    <v-flex xs12 class="ch-search-filter pb-0 pt-0">
      <v-form v-model="valid" ref="form" lazy-validation>
        <v-container fluid grid-list-lg class="pt-0 pb-0">
          <v-layout row wrap class="filter-wrap">
            <button class="form-clear-btn" @click.prevent="clearAllField">
              <i class="fas fa-eraser"></i>
              <span>CLEAR</span>
            </button>
            <v-flex xs1 class="pl-0 pr-0">
              <v-select
                :items="filterBatteryItems"
                item-text="text"
                item-value="value"
                v-model="filterBatteryInput"
                label="Battery"
                bottom
                single-line
                hide-details
                content-class="input-readonly"
                clearable
              ></v-select>
            </v-flex>
            <v-flex xs1 class="pl-0 pr-0">
              <v-select
                :items="filterStatusItems"
                item-text="text"
                item-value="value"
                v-model="filterStatusInput"
                label="Status"
                bottom
                single-line
                hide-details
                content-class="input-readonly"
                clearable
              ></v-select>
            </v-flex>
            <v-flex xs2 class="pl-0 pr-0">
              <v-select
                :disabled="disabledFilterFloor"
                :items="filterFloorItems"
                v-model="filterFloorInput"
                label="floor"
                bottom
                @focus.native="getFloorList"
                @click.native="getFloorList"
                single-line
                hide-details
                content-class="input-readonly"
                clearable
              ></v-select>
            </v-flex>
            <v-flex xs2 class="pl-0 pr-0">
              <v-select
                :disabled="disabledFilterBuilding"
                :items="filterBuildingItems"
                v-model="filterBuildingInput"
                label="Building"
                bottom
                @focus.native="getBuildingList"
                @click.native="getBuildingList"
                single-line
                hide-details
                content-class="input-readonly"
                clearable
              ></v-select>
            </v-flex>
            <v-flex xs2 class="pl-0 pr-0">
              <v-select
                :items="filterHotelItems"
                v-model="filterHotelInput"
                label="Hotel"
                bottom
                @focus.native="getHotelList"
                @click.native="getHotelList"
                autocomplete
                single-line
                hide-details
                clearable
              ></v-select>
            </v-flex>
            <v-flex xs2 class="pl-0 pr-0">
              <v-text-field
                v-model="filterNameInput"
                label="Name"
                single-line
                hide-details
                clearable
              ></v-text-field>
            </v-flex>
            <v-flex xs2 class="pl-0 pr-0">
              <v-text-field
                v-model="filterSerialInput"
                label="Serial"
                single-line
                hide-details
                clearable
              ></v-text-field>
            </v-flex>
          </v-layout>
        </v-container>
      </v-form>
    </v-flex>
  </v-layout>
</template>

<script>
  import _ from 'lodash';
  import { storeFilterEventBus } from '@/components/customized-components/storeFilterEventBus';
  import { doorlocksEventBus } from '@/components/admin/doorlocks/doorlocksEventBus';
  import api from '../../../api';

  export default {
    props: ['storeFilter'],
    data() {
      return {
        id: {
          hotel_id: '',
          building_id: '',
          floor_id: '',
        },
        // NOTE: 모든 검색어
        allSearch: {
          serial: {
            search: null,
            searchCategory: 'serial',
          },
          hotel: {
            search: null,
            searchCategory: 'hotel_id',
          },
          name: {
            search: null,
            searchCategory: 'name',
          },
          building: {
            search: null,
            searchCategory: 'building_id',
          },
          floor_id: {
            search: null,
            searchCategory: 'floor_id',
          },
          status: {
            search: null,
            searchCategory: 'status',
          },
          battery: {
            search: null,
            searchCategory: 'battery',
          },
        },
        valid: true,
        // NOTE: 렌더링 될 변수들
        rootDomainOnly: false,
        filterHotelItems: [],
        filterHotel: null,
        filterBuildingItems: [],
        filterBuilding: null,
        filterFloorItems: [],
        filterFloor: null,
        filterStatus: null,
        filterStatusItems: [
          { text: 'Not installed', value: 'created' },
          { text: 'Installed', value: 'installed' },
          { text: 'Need Update', value: 'updated' },
        ],
        // add
        filterSerialInput: null,
        filterNameInput: null,
        filterFloorInput: null,
        filterBattery: null,
        filterBatteryItems: [
          { text: 'Good', value: 'good' },
          { text: 'Normal', value: 'normal' },
          { text: 'Replace', value: 'replace' },
          // { text: 'Warning', value: 'warning' },
        ],
      };
    },
    methods: {
      /**
       * @description 상세 => 목록으로 넘어올 경우 필터값을 유지, 컴포넌트가 렌더링될 때 최초 한번만 실행
       */
      init() {
        console.log('doorlock filter');
        if (!_.isEmpty(this.storeFilter)) {
          console.log('this.storeFilter not empty');
          const filter = Object.values(this.storeFilter).filter(item => item.search !== null);
          const arr = Object.keys(this.allSearch);
          for (let i = 0; i < arr.length; i += 1) {
            for (let j = 0; j < filter.length; j += 1) {
              if (this.allSearch[arr[i]].searchCategory === filter[j].searchCategory) {
                this.allSearch[arr[i]].search = filter[j].search;
                switch (this.allSearch[arr[i]].searchCategory) {
                  case 'serial':
                    this.filterSerialInput = filter[j].search;
                    break;
                  case 'hotel_id':
                    this.filterHotel = filter[j].search;
                    this.getHotelList();
                    break;
                  case 'name':
                    this.filterNameInput = filter[j].search;
                    break;
                  case 'building_id':
                    this.filterBuilding = filter[j].search;
                    this.getBuildingList();
                    break;
                  case 'floor_id':
                    this.filterFloorInput = filter[j].search;
                    this.getFloorList();
                    break;
                  case 'status':
                    this.filterStatus = filter[j].search;
                    break;
                  case 'battery':
                    this.filterBattery = filter[j].search;
                    break;
                  default:
                    break;
                }
              }
            }
          }
          this.$nextTick(() => {
            console.log('this.$nextTick');
            doorlocksEventBus.$emit('initFilter', this.allSearch);
          });
        }
      },
      clearAllField() {
        this.$refs.form.reset();
      },
      getHotelList() {
        const query = {
          limit: 1000,
        };
        api.getHotelList(query)
        .then((result) => {
          if (result.status === 200) {
            this.filterHotelItems = result.data.map((obj) => {
              const newObj = {};
              newObj.value = obj.id;
              newObj.text = obj.name;
              return newObj;
            });
          }
        })
        .catch((err) => {
          this.alert.type = 'error';
          this.alert.color = 'red';
          this.alert.message = err.response.data.message;
          this.alertOccur();
        });
      },
      getDomainList() {
        api.getDomainList()
        .then((result) => {
          if (result.status === 200) {
            this.filterDomainItems = result.data.map((obj) => {
              const newObj = {};
              newObj.value = obj.id;
              newObj.text = obj.name;
              return newObj;
            });
          }
        })
        .catch((err) => {
          this.alert.type = 'error';
          this.alert.color = 'red';
          this.alert.message = err.response.data.message;
          this.alertOccur();
        });
      },
      getBuildingList() {
        const id = {
          hotel_id: this.filterHotelInput,
        };
        const query = {
          limit: 150,
        };
        api.getBuildingList(id, query)
        .then((result) => {
          if (result.status === 200) {
            this.filterBuildingItems = result.data.map((obj) => {
              const newObj = {};
              newObj.value = obj.id;
              newObj.text = obj.name;
              return newObj;
            });
          }
        })
        .catch((err) => {
          this.alert.type = 'error';
          this.alert.color = 'red';
          this.alert.message = err.response.data.message;
          this.alertOccur();
        });
      },
      getFloorList() {
        const id = {
          hotel_id: this.filterHotelInput,
          building_id: this.filterBuildingInput,
        };
        const query = {
          limit: 150,
        };
        api.getFloorList(id, query)
        .then((result) => {
          if (result.status === 200) {
            this.filterFloorItems = result.data.map((obj) => {
              const newObj = {};
              newObj.value = obj.id;
              newObj.text = obj.name;
              return newObj;
            });
          }
        })
        .catch((err) => {
          this.alert.type = 'error';
          this.alert.color = 'red';
          this.alert.message = err.response.data.message;
          this.alertOccur();
        });
      },
      /**
       * @description 사용자가 입력을 기다리는 시간(밀리세컨드) 입니다.
       * @param { Object } object, this.allSearch
       */
      getInputValue: _.debounce((obj) => {
        doorlocksEventBus.$emit('customFilter', obj);
        storeFilterEventBus.$emit('setFilter', obj);
      }, 100),
    },
    computed: {
      filterDomainInput: {
        get() {
          return this.filterDomain;
        },
        set(newValue) {
          this.filterDomain = newValue;
          this.allSearch.domain_name.search = newValue;
          doorlocksEventBus.$emit('customFilter', this.allSearch);
          storeFilterEventBus.$emit('setFilter', this.allSearch);
        },
      },
      filterHotelInput: {
        get() {
          return this.filterHotel;
        },
        set(newValue) {
          console.log('filterHotelInput');
          this.filterHotel = newValue;
          this.allSearch.hotel.search = newValue;
          this.filterBuilding = null;
          this.filterBuildingItems = [];
          this.filterFloor = null;
          this.filterFloorItems = [];
          this.allSearch.building.search = null;
          this.allSearch.floor_id.search = null;
          doorlocksEventBus.$emit('customFilter', this.allSearch);
          storeFilterEventBus.$emit('setFilter', this.allSearch);
        },
      },
      filterBuildingInput: {
        get() {
          return this.filterBuilding;
        },
        set(newValue) {
          console.log('filterBuildingItems');
          this.filterBuilding = newValue;
          this.allSearch.building.search = newValue;
          this.filterFloor = null;
          this.filterFloorItems = [];
          this.allSearch.floor_id.search = null;
          doorlocksEventBus.$emit('customFilter', this.allSearch);
          storeFilterEventBus.$emit('setFilter', this.allSearch);
        },
      },
      filterStatusInput: {
        get() {
          return this.filterStatus;
        },
        set(newValue) {
          console.log('filterStatusInput');
          this.filterStatus = newValue;
          this.allSearch.status.search = newValue;
          doorlocksEventBus.$emit('customFilter', this.allSearch);
          storeFilterEventBus.$emit('setFilter', this.allSearch);
        },
      },
      filterBatteryInput: {
        get() {
          return this.filterBattery;
        },
        set(newValue) {
          console.log('filterBatteryInput');
          this.filterBattery = newValue;
          this.allSearch.battery.search = newValue;
          doorlocksEventBus.$emit('customFilter', this.allSearch);
          storeFilterEventBus.$emit('setFilter', this.allSearch);
        },
      },
      disabledFilterBuilding() {
        if (this.filterHotel) return false;
        return true;
      },
      disabledFilterFloor() {
        if (this.filterBuilding) return false;
        return true;
      },
    },
    watch: {
      /**
       * @description 작업을 실행할 수 있는 빈도를 제한합니다
       */
      filterSerialInput(newValue) {
        console.log('filterSerialInput');
        this.allSearch.serial.search = newValue;
        this.getInputValue(this.allSearch);
      },
      filterNameInput(newValue) {
        console.log('filterNameInput');
        this.allSearch.name.search = newValue;
        this.getInputValue(this.allSearch);
      },
      filterFloorInput(newValue) {
        console.log('filterDomainInput');
        this.allSearch.floor_id.search = newValue;
        this.getInputValue(this.allSearch);
      },
    },
    created() {
      this.rootDomainOnly = localStorage.getItem('domain_type') === 'root';
    },
    mounted() {
      this.init();
    },
    beforeDestroy() {
      doorlocksEventBus.$off('initFilter');
      doorlocksEventBus.$off('customFilter');
    },
  };
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/admin/doorlocks/DoorlocksFilter.vue